import { Col, DatePicker, Form, Input, notification, Row, Select } from 'antd';
import locale from 'antd/es/date-picker/locale/vi_VN';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import authAPI from '~/api/AuthAPI';
import serviceAPI from '~/api/ServiceAPI';
import { SVGS } from '~/assets/assetsPath';
import { checkKeyDownNumberInput } from '~/utils';
import styles from './FormContact.module.scss';

const cx = classNames.bind(styles);

const Service = styled.div`
    .ant-select.ant-select-in-form-item {
        height: 44px;
    }
    .ant-select-selector {
        height: 44px;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        height: 44px;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: none;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        height: 44px;
    }
    .ant-select-selection-placeholder {
        height: 44px;
        align-items: center;
        display: flex;
    }
    .ant-select-selection-item {
        height: 44px;
        align-items: center;
        display: flex;
    }
    .ant-select-selection.ant-select-selection--single {
        height: 44px;
    }

    .ant-select-selection-selected-value {
        height: 44px;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        padding-right: 30px;
    }
`;

const DateTime = styled.div`
    .ant-picker {
        height: 44px;
        width: 100%;
    }
`;

const FormContact = () => {
    const [serviceList, setServiceList] = useState(null);
    const [form] = Form.useForm();
    const defaultValues = {
        fullname: '',
        phone: '',
        email: '',
        service_id: null,
        time: 0,
        note: '',
    };
    form.setFieldsValue(defaultValues);

    const onServiceChange = (value) => {
        form.setFieldsValue({ service_id: value });
    };

    const onChangeDate = (date) => {
        form.setFieldsValue({ time: moment(date).valueOf() });
    };

    const [disableSubmit, setDisableSubmit] = useState(false);

    const onFinish = async (data) => {
        if (disableSubmit) {
            return;
        } else {
            setDisableSubmit(true);
            try {
                const res = await authAPI.userRegsiterTesting(data);
                if (res.code === 200) {
                    form.resetFields();
                    notification.open({
                        message: 'Successfully registered for consulting',
                        duration: 2,
                        placement: 'top',
                    });
                }
                setDisableSubmit(false);
            } catch (err) {
                console.log(err);
                if (err.message) {
                    notification.open({
                        message: err.message,
                        duration: 2,
                        placement: 'top',
                    });
                }
                setDisableSubmit(false);
            }
        }
    };

    const getService = async () => {
        try {
            const res = await serviceAPI.getListServiceAPI({
                fields: '["$all"]',
            });
            setServiceList(res?.results?.objects?.rows);
        } catch (error) {}
    };

    useEffect(() => {
        getService();
    }, []);

    // const disabledHours = () => {
    //     const hours = [];
    //     for (let i = 0; i < moment().hour(); i += 1) hours.push(i);
    //     return hours;
    // };

    // const disabledMinutes = (selectedHour) => {
    //     const minutes = [];
    //     if (selectedHour === moment().hour()) {
    //         for (let i = 0; i < moment().minute(); i += 1) minutes.push(i);
    //     }
    //     return minutes;
    // };
    return (
        <div style={{ backgroundImage: `url(${SVGS.BackgroundFormContact})` }} className={cx('wrapper')}>
            <Row align="middle">
                <Col xs={24} md={13}>
                    <Form onFinish={onFinish} form={form}>
                        <Row justify="center">
                            <Form.Item>
                                <Row justify="center" className={cx('name_page')}>
                                    Sign up for consultation & experience
                                </Row>
                            </Form.Item>
                        </Row>
                        <Row justify="center">
                            <Col xs={12}>
                                <Form.Item
                                    name="fullname"
                                    className={cx('item')}
                                    rules={[
                                        { required: true, message: 'Please enter your full name' },
                                        { max: 50, message: 'Maximum name 50 characters' },
                                    ]}
                                >
                                    <Input placeholder="Name *" className={cx('item_input')} />
                                </Form.Item>
                            </Col>
                            <Col xs={12}>
                                <Form.Item
                                    name="phone"
                                    className={cx('item')}
                                    rules={[
                                        { required: true, message: 'Please enter phone number' },
                                        {
                                            // pattern: new RegExp(/^[0-9\S]*$/),
                                            pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                            message: 'Wrong phone number format',
                                        },
                                        { min: 10, message: 'Phone number must have 10 digits' },
                                    ]}
                                >
                                    <Input
                                        placeholder="Phone number *"
                                        onKeyDown={checkKeyDownNumberInput}
                                        maxLength={10}
                                        className={cx('item_input')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col xs={12}>
                                <Form.Item
                                    name="email"
                                    className={cx('item')}
                                    rules={[{ type: 'email', message: 'Incorrect email address' }]}
                                >
                                    <Input placeholder="Email" className={cx('item_input')} />
                                </Form.Item>
                            </Col>
                            <Col xs={12}>
                                <Form.Item name="service_id" className={cx('item')}>
                                    <Service>
                                        <Select placeholder="Select service" onChange={onServiceChange}>
                                            {serviceList &&
                                                serviceList.length > 0 &&
                                                serviceList?.map((item) => {
                                                    return (
                                                        <Select.Option value={item?.id} key={item?.id}>
                                                            {item?.title}
                                                        </Select.Option>
                                                    );
                                                })}
                                        </Select>
                                    </Service>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Form.Item
                                name="time"
                                className={cx('item')}
                                style={{ width: '100%' }}
                                rules={[{ type: 'time', required: true, message: 'Please select date and time!' }]}
                            >
                                <DateTime>
                                    <DatePicker
                                        placeholder="Date and time"
                                        format="HH:mm, DD/MM/YYYY"
                                        showTime={{
                                            defaultValue: moment(`${moment().hour()}:${moment().minute()}`, 'HH:mm'),
                                            format: 'HH:mm',
                                        }}
                                        onChange={onChangeDate}
                                        // disabledHours={disabledHours}
                                        // disabledMinutes={disabledMinutes}
                                        disabledDate={(current) => {
                                            let customDate = moment().format('YYYY-MM-DD');
                                            return current && current <= moment(customDate, 'YYYY-MM-DD');
                                        }}
                                        locale={locale}
                                        // onSelect={(value) => {
                                        //     form.setFieldValue('time', value);
                                        //     // form.setFieldValue('time', moment(value).valueOf());
                                        //     // form.setFieldsValue({ time: moment(value).valueOf() });
                                        // }}
                                        inputReadOnly={true}
                                    />
                                </DateTime>
                            </Form.Item>
                        </Row>
                        <Row justify="center">
                            <Form.Item name="note" className={cx('item')} style={{ width: '100%' }}>
                                <Input.TextArea rows={4} placeholder="Notes" className={cx('item_input')} />
                            </Form.Item>
                        </Row>
                        <Form.Item style={{ marginTop: '30px' }}>
                            <button htmlType="submit" disabled={disableSubmit} className={cx('btn_login')}>
                                Register
                            </button>
                        </Form.Item>
                    </Form>
                </Col>
                <Col xs={11}>
                    <Row className={cx('col_image')}>
                        <img src={SVGS.ImageFormContact} alt="" style={{ width: '100%' }} />
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default FormContact;
